/** Sohbet mesajlarının GÖSTERİM sırası — zaman önce, id yalnız eşitlik ayracı.
 *
 *  Neden id yetmiyor: eski belge yazışmasından taşınan mesaj orijinal tarihini
 *  korur ama yeni (yüksek) bir id alır. id'ye göre sıralanırsa aylar önce
 *  yazılmış mesaj kanalın en altına düşer ve "az önce geldi" gibi görünür.
 *  Sunucu da aynı sırayı uygular (chat_service._chrono_key) — ikisi ayrışırsa
 *  aynı konuşma iki ekranda farklı sıralanır. */
export const byChrono = (a, b) => {
  const ta = Date.parse(a?.created_at || '') || 0
  const tb = Date.parse(b?.created_at || '') || 0
  if (ta !== tb) return ta - tb
  return (a?.id || 0) - (b?.id || 0)
}

/** "Daha eski" imleci — EKRANDAKİ ilk mesaj değil, EN KÜÇÜK id.
 *  Sayfalama id imlecine dayanır; taşınan mesaj listenin başına geçtiğinde
 *  messages[0].id yüksek bir değer olur ve zaten yüklenmiş sayfayı tekrar ister. */
export const minMessageId = (list) => {
  let m = null
  for (const x of list || []) {
    const id = Number(x?.id)
    if (Number.isFinite(id) && (m === null || id < m)) m = id
  }
  return m
}
